<script lang="ts" setup>
import {
  BlockCarouselManualFields,
  BlockFooterCTAFields,
  BlockImageTextFields,
  BlockPoolNavigationFields,
  BlockSingleQuoteFields,
} from '~/utils/CmsBlockFields'

const { $directus, $readSingleton } = useNuxtApp()

const { data } = await useAsyncData('pool_overview', async () => {
  return $directus.request($readSingleton('pool_overview', {
    fields: ['*', {
      seo: ['*', {
        translations: ['*'],
      }],
      translations: ['*'],
      hero_image: ['*'],
      hero_video: ['*'],

      blocks: [
        'collection',
        'id',
        {
          item: {
            block_carousel_manual: BlockCarouselManualFields, //
            block_pool_navigation: BlockPoolNavigationFields, //
            block_single_quote: BlockSingleQuoteFields, //
            block_image_text: BlockImageTextFields, //
            block_footer_cta: BlockFooterCTAFields, //
            block_pool_index: ['*'], //
          },
        },
      ],
    }],
  }))
})
</script>

<template>
  <div>
    <HeroIndex :data="(data as any)" />
    <div>
      <div v-for="block in data?.blocks" :key="block.id">
        <BlockPoolNavigation v-if="block.collection === 'block_pool_navigation'" />
        <BlockSingleQuote v-if="block.collection === 'block_single_quote'" :data="block.item" />
        <BlockImageText v-if="block.collection === 'block_image_text'" :data="block.item" />
        <BlockCarouselManual v-if="block.collection === 'block_carousel_manual'" :data="block.item" />
        <BlockFooterCTA v-if="block.collection === 'block_footer_cta'" :data="block.item" />
        <BlockPoolIndex v-if="block.collection === 'block_pool_index'" />
      </div>
    </div>
  </div>
</template>

<style>

</style>
